@use "../../sass/variables/animation";
@use "../../sass/variables/paddings";
@use "../../sass/variables/typography";
@use "../../sass/variables/z-index";
@use "../../sass/mixins/font-family";
@use "../../sass/mixins/select";

.ux-dropdown {
  @include font-family.font(bold);
  display: block;
  font-size: typography.$size-text-smaller;
  position: relative;
  text-transform: uppercase;

  &__label {
    @include select.dropdown-button-base;
    align-items: center;
    display: flex;
    height: auto;
    justify-content: space-between;
    min-height: var(--ux-input-height);
    padding: var(--ux-dropdown-padding);

    &:focus-visible {
      outline: var(--ux-select-focus-border-width) solid var(--ux-button-focus-border-color);
      border-color: var(--ux-button-focus-border-color);
    }

    &:focus-visible+.ux-dropdown__dropdown-locator .ux-dropdown__menu {
      outline: var(--ux-select-focus-border-width) solid var(--ux-button-focus-border-color);
      border-color: var(--ux-button-focus-border-color);
      outline-offset: var(--ux-input-outline-offset);
    }

    ux-icon {
      fill: currentColor;
      font-size: var(--ux-select-icon-size);
      transition: transform animation.$animationSpeed-fast ease-out;
    }
  }

  &__label--light {
    @include font-family.font(light);
    font-size: typography.$size-text-medium;
    padding-bottom: var(--ux-input-padding-vertical);
    padding-top: var(--ux-input-padding-vertical);
    text-transform: none;
  }

  &__counter {
    display: inline-block;
    background-color: var(--ux-button-selected-bg-color);
    color: var(--ux-button-selected-text-color);
    border-radius: 50%;
    width: 21px;
    height: 21px;
    text-align: center;
    line-height: 1.6;
    margin-left: 15px;
  }

  &__dropdown-locator {
    position: absolute;
    top: calc(100% - 1px);
    transform: scaleY(0);
    transform-origin: top;
    transition: transform animation.$animationSpeed-fast animation.$animationEasing-easeInOut;
    width: 100%;
    z-index: z-index.$z-index-dropdown-element;
  }

  &__menu {
    background-color: var(--ux-input-background-color);
    border: var(--ux-input-border-width) solid var(--ux-button-border-color);
    border-top: 0;

    .ux-list__filter-input {
      border-left: 0;
      border-right: 0;
      margin-bottom: 10px;
      padding-left: paddings.$dropdown-padding-horizontal;
      padding-right: paddings.$dropdown-padding-horizontal;
    }
  }

  &__menu--radio-items {
    padding-bottom: 10px;
  }

  &__list {
    padding: 10px 10px 10px 0;

    > li {
      padding: 0 paddings.$dropdown-padding-horizontal;
    }
  }

  &.ux-dropdown--down {
    .ux-dropdown__label ux-icon {
      transform: rotate(180deg);
    }

    .ux-dropdown__dropdown-locator {
      transform: scaleY(1);
    }
  }
}
